import styled, { css } from 'styled-components';
import { makeStyles, createStyles, MuiTheme, color, resolveStringOrNumberStyle } from '@kis-technologies/kis-ui';

interface KeyProps {
  width?: string | number;
  first?: boolean;
  bg?: 'primary' | 'secondary';
  fontFamily?: string;
}

interface KeyboardRowProps {
  first?: boolean;
}

const raised = css`
  box-shadow:
    0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);

  &:hover {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);
  }
`;

const width = (props: KeyProps) =>
  props.width &&
  css`
    max-width: ${resolveStringOrNumberStyle(props.width)};
  `;

const bg = (props: KeyProps) => {
  switch (props.bg) {
    case 'primary':
      return css`
        background: ${color.PRIMARY};
        color: ${color.WHITE};

        &[disabled] {
          background: ${color.LIGHT_GRAY};
          border-color: ${color.LIGHT_GRAY};
          color: ${color.DARK_GRAY};
          cursor: not-allowed;
        }
      `;
    case 'secondary':
      return css`
        background: ${color.SECONDARY};
        color: ${color.WHITE};

        &[disabled] {
          background: ${color.LIGHT_GRAY};
          border-color: ${color.LIGHT_GRAY};
          color: ${color.DARK_GRAY};
        }
      `;
    default:
      return css`
        background: ${color.WHITE};
        color: ${color.BLACK};
      `;
  }
};

const first = (props: KeyProps) =>
  props.first
    ? css`
        justify-content: center;
      `
    : css`
        justify-content: space-between;
      `;

export const Key = styled.button<KeyProps>`
  flex: 1;
  height: 68px;
  border-radius: 8px;
  max-width: 124px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  cursor: pointer;
  text-decoration: none;
  border: none;
  outline: none;
  font-family: ${({ fontFamily }) => fontFamily};
  ${raised};
  ${width};
  ${bg};
`;

export const KeyboardRow = styled.div<KeyboardRowProps>`
  display: flex;
  align-items: center;
  // overflow: hidden;
  padding-bottom: 10px;
  & ${Key} {
    margin-left: 9px;
    margin-right: 9px;
  }
  ${first}
`;

export const KeyboardContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 32px 16px 40px;
  height: 480px;
  background: transparent;
  & ${KeyboardRow}:not(:last-child) {
    margin-bottom: 0px;
  }

  & ${KeyboardRow}:last-child {
    margin-bottom: 0;
  }
`;

export const SuggestionsContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -32px;
`;
export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    keyboardNextButton: {
      width: '475px',
      [theme.breakpoints.down('lg')]: {
        width: '100%',
        minWidth: '285px',
        maxWidth: '425px'
      }
    },
    keyboardPreviousButton: {
      width: '475px',
      [theme.breakpoints.down('lg')]: {
        width: '100%',
        minWidth: '285px',
        maxWidth: '425px'
      }
    },
    suggestionButton: {
      minWidth: '373px',
      width: 'fit-content',
      margin: '0px 22px',
      [theme.breakpoints.down('lg')]: {
        minWidth: '240px',
        margin: '0px 0px'
      }
    }
  })
);

export const CaretContainer = styled.div`
  position: absolute;
  right: 25px;
  background: white;
  border-radius: 50px;
  padding: 14px 18px;
  top: -25px;
`;
